import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const warmupDataRuntime = createHostModule({
    get: ({ channel }) => function get(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'warmupData.get',
            args,
        });
    },
    set: ({ channel }) => function set(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'warmupData.set',
            args,
        });
    },
});
//# sourceMappingURL=warmupData.runtime.js.map